<template>
  <div :class="[!v2 ? item.soldat ? 'product-header-item soldat' : 'product-header-item' : '', { '-watch-clinic': clinic }]" @click="productZoomGallery === true && handleOpenZoomGallery()">
    <lazy-image :class-name="[item.soldat ? 'product-header-item-image soldat' : 'product-header-item-image', { '-half-width': !fullWidth }]" ref="picture" :item="picture" :sizes="sizes" rootMargin="0px" :loading="loading" :render-when-appeared="renderWhenAppeared"></lazy-image>
  </div>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'
import ImageManager from 'vue-storefront-prismic-ssr/utilities/ImageManager'
import LazyImage from './utils/LazyImage'

export default {
  props: ['item', 'index', 'full-width', 'v2', 'clinic', 'render-when-appeared', 'loading', 'productZoomGallery'],
  name: 'ProductHeaderItem',
  mixins: [ReadyHook],
  components: {
    LazyImage
  },
  computed: {
    picture() {
      return {
        url: this.item.src,
        lowDefinitionUrl: ImageManager.getLowDefinition(this.item.src, 150, 1.25, true, 4),
        srcset: ImageManager.getSrcSet(this.item.src, 1200, 200, 100, 1.25, true),
        alt: this.item.alt || '',
        width: this.item.width,
        height: this.item.height
      }
    },
    sizes() {
      if (this.item.soldat) {
        return '(max-width: 575px) 80vw, (max-width: 991px) 50vw, 35vw'
      } else {
        return '(max-width: 992px) 100vw, 70vw'
      }
    }
  },
  methods: {
    handleOpenZoomGallery() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';
.product-header-item {
  width:100%;
  height: 100%;

  &:not(.-watch-clinic) {
    .product-header-item-image {
      width:100%;
      height: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      /deep/ img {
        width: 100%;
        height:100%;
        object-fit: cover;
      }

      &.soldat {
        max-height: 72vh;
        width: 70%;

        @media (min-width: 321px) {
          width: 80%;
        }
        @include bp(sm) {
          width: 65%;
        }
        @include bp(md) {
          width: 48%;
        }
        @include bp(lg) {
          height: 55rem;
          width: 70%;
        }
        /deep/ img {
          object-fit: contain;
        }
      }

      &.-half-width {
        position: relative;
        top: auto;
        left: auto;
        transform: none;
        max-height: unset;
        width: 100%;
        height: 0;
        padding-bottom: 125%; // aspect ratio 4:5 (5/4 = 1.25)

        /deep/ img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
